import Home from "../../views/Home.vue";
import Login from "../user/auth/pages/Login.vue";
import Recovery from "../user/auth/pages/Recovery.vue";
import ForecastTool from "../forecast-tool/pages/ForecastTool";
import ConsensusReport from "../consensus-report/pages/ConsensusReport";
import HistoricalDataVisualization from "../historical-data-visualization/pages/HistoricalDataVisualization";
import ShortTerm from "../short-term/pages/ShortTerm.vue";
import WhitePaper from "../white-paper/pages/whitePaper";
import Backtesting from "../backtesting/pages/Backtesting.vue";
import CountryTable from "../country-tables/pages/CountryTable.vue";
import TradingStrategy from "../trading-strategy/pages/TradingStrategy.vue";

export const AppRoutes = [
  {
    path: "/",
    name: "all",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/recovery",
    name: "Recovery",
    component: Recovery,
  },
  {
    path: "/medium-term-forecaster",
    name: "forecast-tool",
    component: ForecastTool,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/consensus-report",
    name: "consensus-report",
    component: ConsensusReport,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/historical-data-visualization",
    name: "historical-data-visualization",
    component: HistoricalDataVisualization,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shock-simulator",
    name: "short-term",
    component: ShortTerm,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/white-paper",
    name: "white-paper",
    component: WhitePaper,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/backtesting",
    name: "backtesting-view",
    component: Backtesting,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/comparative-country-tables",
    name: "country-table-view",
    component: CountryTable,
    meta: {
      requiresAuth: true,
    },
  },
  {
    // the Weekly Report section was retired; keep old links working
    path: "/weekly-report",
    redirect: "/historical-data-visualization",
  },
  {
    path: "/trading-strategy",
    name: "trading-strategy",
    component: TradingStrategy,
    meta: {
      requiresAuth: true,
    },
  },
];
